import type { IssueCount } from "../../data/useIssueCounts";
import { formatInt, formatPerc } from "../../lib/utils";
import Table from "react-bootstrap/Table";

interface RankedIssueTableProps {
  issues: IssueCount[];
  totalSurveys: number;
}

export default function RankedIssueTable({
  issues,
  totalSurveys,
}: RankedIssueTableProps): JSX.Element {
  const sortedIssues = [...issues].sort((a, b) => {
    return b.count - a.count !== 0
      ? b.count - a.count
      : a.issue.localeCompare(b.issue);
  });

  return (
    <Table responsive striped className="break-before">
      <thead>
        <th>Theme</th>
        <th>Issue</th>
        <th className="numcell">Count of issue</th>
        <th className="numcell">% of Phase 1 surveys</th>
      </thead>
      <tbody>
        {sortedIssues.map((issue) => (
          <tr key={issue.issue}>
            <td>{issue.theme}</td>
            <td>{issue.issue}</td>
            <td className="numcell">{formatInt(issue.count)}</td>
            <td className="numcell">
              {formatPerc(issue.count / totalSurveys)}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
